// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/devtools/components/modals/IARModal.module.css';
import type {IARActionCardConfig} from '@app/features/devtools/components/modals/IARModal.types';
import {Button} from '@app/features/ui/button/Button';
import type React from 'react';

interface IARActionCardsProps {
	title: string;
	cards: ReadonlyArray<IARActionCardConfig>;
}
export const IARActionCards: React.FC<IARActionCardsProps> = ({title, cards}) => {
	if (cards.length === 0) {
		return null;
	}
	return (
		<div className={styles.actionListWrap}>
			<div className={styles.actionListTitle}>{title}</div>
			<div className={styles.actionList}>
				{cards.map((card) => (
					<div key={card.id} className={styles.actionRow}>
						<div className={styles.actionRowText}>
							<div className={styles.actionRowTitle}>{card.title}</div>
							<div className={styles.actionRowDesc}>{card.description}</div>
						</div>
						<Button variant={card.buttonVariant ?? 'secondary'} small fitContent onClick={card.onClick}>
							{card.label}
						</Button>
					</div>
				))}
			</div>
		</div>
	);
};
